import { StepId } from '../../api/useRiskToleranceWorkflowQuery';

export interface FormValues {
  [StepId.HypotheticalPortfolio]: number;
}

export const ariaLabel =
  'Choose from the five hypothetical portfolios shown. The values for each portfolio represent two possible returns (low and high) after one year.';

export const options = [
  { value: 1, name: 'Portfolio A', worstCase: 55000, bestCase: 160000 },
  { value: 2, name: 'Portfolio B', worstCase: 65000, bestCase: 150000 },
  { value: 3, name: 'Portfolio C', worstCase: 75000, bestCase: 135000 },
  { value: 4, name: 'Portfolio D', worstCase: 85000, bestCase: 125000 },
  { value: 5, name: 'Portfolio E', worstCase: 95000, bestCase: 115000 },
];
